import React from 'react';
import { Color } from 'src/theme/color';

interface IColor {
	textColor: string;
	backgroundColor: string;
	callToActionColor: string;
	callToActionTextColor: string;
}

const emptyColors: IColor = {
	textColor: '#FFFFFF',
	backgroundColor: Color.BACKGROUND,
	callToActionColor: Color.ACTION,
	callToActionTextColor: '#FFFFFF',
};

export const GameColorsProvider = ({ children, value }: { children: React.ReactNode; value: IColor }) => {
	return <GameColorsContext.Provider value={value}>{children}</GameColorsContext.Provider>;
};

const GameColorsContext = React.createContext<IColor>(emptyColors);

export const useGameColorsProvider = () => {
	return React.useContext(GameColorsContext);
};
